import React, { Component } from "react";
import { Button, Tooltip, message, Icon, Modal } from "antd";
import ExportUtil from '../../../common/ExportUtil'
import API_URL from "../../../common/url";
import Filter from "./Filter";
import TableC from "../../basicElement/TableC";
import $ from '../../../common/AjaxRequest';
import SideNav from '../SideNav';
import fp from "../../../utils/fp";
import cf from "../../../utils/cf";
import moment from "moment";
import "../../clinicalEvaluation/clinicalEvaluationRecord/index.less";
import { saveParams } from '../../../actions/noticeActions';
import { saveEvaluateParams } from '../../../actions/clinicalEvaluationActions';
import { connect } from "react-redux";
import SchemeInfor from "../../clinicalEvaluation/clinicalEvaluationRecord/SchemeInfor";
import VersionRecord from "../../clinicalEvaluation/clinicalEvaluationRecord/VersionRecord";
import UpdateLog from "../../clinicalEvaluation/clinicalEvaluationRecord/UpdateLog";
import OperationLog from "../../clinicalEvaluation/clinicalEvaluationRecord/OperationLog";
import OperateReason from "../../clinicalEvaluation/clinicalEvaluationRecord/OperateReason";
import TotalPriceModal from "../../clinicalEvaluation/clinicalEvaluationRecord/TotalPriceModal";
import SecEvaluation from "../../clinicalEvaluation/clinicalEvaluationRecord/SecEvaluation";
import QuoteVersionRecord from "../../clinicalEvaluation/clinicalEvaluationRecord/QuoteVersionRecord";
import FinalQuotation from "../../clinicalEvaluation/clinicalEvaluationRecord/FinalQuotation";
import Update from "../../clinicalEvaluation/clinicalEvaluationRecord/Update";
import ConfirmTotalPiceModal from "./ConfirmTotalPiceModal";
import FloorPriceModal from "../../clinicalEvaluation/clinicalEvaluationRecord/FloorPriceModal";
import TotalPiceRequestRecord from "./TotalPiceRequestRecord";
import UserDetail from "../../investigation/UserDetail";

class BusinessOfferRecord extends Component {
    state = {
        data: [],
        loading: false,
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        const urlParams = this.getUrlParams(); //urlParams为url地址问号后面的数据
        const { params, evaluateParams } = this.props; //params为消息通知传来的数据；evaluateSearchParams为页面返回时，原先保留的数据
        const { evaluateSearchParams, evaluatePagination, feedBack } = evaluateParams;
        this.setState({
            searchParams: feedBack ? { ...evaluateSearchParams, ...urlParams } : { ...params, ...urlParams },
            pagination: feedBack ? { ...evaluatePagination } : this.state.pagination,
        }, () => {
            if (feedBack) {
                this.props.saveEvaluateParams({
                    evaluatePagination: {},
                    evaluateSearchParams: {},
                    feedBack: false,
                });
            };
            this.loadData();
        })
    }

    componentWillUnmount() {
        this.props.saveParams({
            evaluateCode: undefined,
        });
    }

    getUrlParams = () => {
        let href = window.location.href;
        let obj = {};
        if (href.includes("?")) {
            let query = href.substring(href.indexOf("?") + 1);
            let item = query.split("&");
            for (let i = 0; i < item.length; i++) {
                let arr = item[i].split("=");
                obj[arr[0]] = arr[1];
            }
        };
        return obj
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { researchProductTypeId = [] } = searchParams;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const curParams = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryQuotationListByParams,
            data: {
                offset: current,
                limit: pageSize,
                ...curParams,
                researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            }
        };
        $.sendRequest(options);
    };

    search = () => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({ pagination },
            () => {
                this.loadData();
            }
        );
    };

    showSchemeInfor = (record) => {
        this.SchemeInforRef.show(record);
    }

    getColumns = () => {
        const columns = [
            {
                title: '临床评估单号',
                dataIndex: 'evaluateCode',
                key: 'evaluateCode',
                width: 100,
                fixed: 'left',
            }, {
                title: '业务机会编号',
                dataIndex: 'businessOpportunityNum',
                key: 'businessOpportunityNum',
                width: 100,
                fixed: 'left',
            }, {
                title: '报价状态',
                dataIndex: 'evaluateStatusShow',
                key: 'evaluateStatusShow',
                width: 100,
                fixed: 'left',
            }, {
                title: '需求紧急程度',
                dataIndex: 'quotationUrgentLevelValue',
                key: 'quotationUrgentLevelValue',
                width: 100,
            }, {
                title: '预计给到客户时间',
                dataIndex: 'estimatedDeliveryTime',
                key: 'estimatedDeliveryTime',
                width: 100,
            }, {
                title: '报价类型',
                dataIndex: 'basicQuotationTypeValue',
                key: 'basicQuotationTypeValue',
                width: 100,
                render: (text, record) => {
                    const { quotationTypeList } = record;
                    return <div>
                        {
                            (quotationTypeList || []).map((el, index, arr) => {
                                if (el.crmQuotationTypeLink) {
                                    return <a onClick={() => window.open(`${el.crmQuotationTypeLink}`)}>
                                        {el.basicQuotationTypeName}{(index !== arr.length - 1) && '，'}
                                    </a>
                                } else {
                                    return <span>{el.basicQuotationTypeName}{(index !== arr.length - 1) && '，'}</span>
                                }
                            })
                        }
                    </div>
                }
            }, {
                title: '报价对象',
                dataIndex: 'submissionTarget',
                key: 'submissionTarget',
                width: 100,
            }, {
                title: '方案编号',
                dataIndex: 'evaluateSerialNumber',
                key: 'evaluateSerialNumber',
                width: 100,
                render: (text, record) => <a onClick={() => this.showSchemeInfor(record)}>{text}</a>
            }, {
                title: '临床分期',
                dataIndex: 'investigationByStageNames',
                key: 'investigationByStageNames',
                width: 100,
            }, {
                title: '适应症',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 100,
            }, {
                title: '底价（含税）/人民币',
                dataIndex: 'floorPriceIncludeTax',
                key: 'floorPriceIncludeTax',
                width: 100,
                render: (text, record) => {
                    const { bindFloorPriceIncludeTax, noBindFloorPriceIncludeTax } = record;
                    return text ?
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={<div>
                        <div>盲态服务：{bindFloorPriceIncludeTax}</div>
                        <div>非盲服务：{noBindFloorPriceIncludeTax}</div>
                    </div>}> 
                        <span style={{
                            top: '0px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                            position: 'absolute',
                            display: 'flex',
                            paddingLeft: 10,
                            alignItems: 'center',
                        }} >
                            {`${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </span>
                    </Tooltip> 
                    : ''
                } 
            }, {
                title: '评估底价单例金额（含税）',
                dataIndex: 'evaluateBasicPriceTax',
                key: 'evaluateBasicPriceTax',
                width: 120,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }, {
                title: '最终报价金额（含税）/人民币',
                dataIndex: 'finalQuotationAmountTax',
                key: 'finalQuotationAmountTax',
                width: 120,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }, {
                title: '（最终报价）单例报价金额（含税）/人民币',
                dataIndex: 'singletonPriceAmountTax',
                key: 'singletonPriceAmountTax',
                width: 180,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }, {
                title: '研究产品类型',
                dataIndex: 'researchProductTypeName',
                key: 'researchProductTypeName',
                width: 100,
            }, {
                title: '试验药物（或器械/试剂）名称',
                dataIndex: 'investigationMedicine',
                key: 'investigationMedicine',
                width: 120,
            }, {
                title: '治疗领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 100,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 100,
            }, {
                title: '领域leader',
                dataIndex: 'talNameCode',
                key: 'talNameCode',
                width: 120,
                render: (text, record) => {
                    const { talList } = record;
                    const result = (talList || []).map((el, index, arr) => {
                        return <a key={index} onClick={() => this.UserDetailRef.show(el.userId)}>{`${el.userCompellation}[${el.employeeCode}]`}{index < arr.length - 1 ? ';' : ''}<br /></a>;
                    });
                    return result
                }
            }, {
                title: 'PM',
                dataIndex: 'pmName',
                key: 'pmName',
                width: 120,
                render: (text, record) => {
                    const { pmName, pmCode, evaluateUserId } = record;
                    return pmName ? <a onClick={() => this.UserDetailRef.show(evaluateUserId)}>{`${pmName}[${pmCode}]`}</a> : ''
                }
            }, {
                title: '申请人BD',
                dataIndex: 'bdName',
                key: 'bdName',
                width: 100,
                render: (text, record) => {
                    const { crmBdName } = record;
                    return text ? <span>
                        {text}
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={crmBdName}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="solution" /></a>
                        </Tooltip>
                    </span>
                        : ''
                }
            }, {
                title: '申请人BA',
                dataIndex: 'baName',
                key: 'baName',
                width: 100,
                render: (text, record) => {
                    const { crmBaName } = record;
                    return text ? <span>
                        {text}
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={crmBaName}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="solution" /></a>
                        </Tooltip>
                    </span>
                        : ''
                }
            }, {
                title: '建议底价方式（底价测算方式）',
                dataIndex: 'basePriceStatus',
                key: 'basePriceStatus',
                width: 120,
                render: (text, record) => {
                    const { basePriceStatus } = record;
                    return text == 'FTE' ? '一口价（建议评估）' : '访视制';
                }
            }, {
                title: '评估底价GP',
                dataIndex: 'gpCalcuationValue',
                key: 'gpCalcuationValue',
                width: 120,
                render: text => (text == null)  ? `` : `${text}%`
            }, {
                title: '评估标访单价(不含税)',
                dataIndex: 'evaluateStandardVisitAmountNoTax',
                key: 'evaluateStandardVisitAmountNoTax',
                width: 120,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }, {
                title: 'award GP',
                dataIndex: 'gpValue',
                key: 'gpValue',
                width: 120,
                render: text => (text == null)  ? `` : `${text}%`
            }, {
                title: 'Award商机金额（含税）',
                dataIndex: 'awardBusinessAmount',
                key: 'awardBusinessAmount',
                width: 120,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }, {
                title: 'award标访单价（不含税）',
                dataIndex: 'awardStandardVisitAmount',
                key: 'awardStandardVisitAmount',
                width: 120,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }, {
                title: '评估标准访视数量',
                dataIndex: 'planStandardVisitAmount',
                key: 'planStandardVisitAmount',
                width: 120,
            }, {
                title: '评估FTE',
                dataIndex: 'evaluateFte',
                key: 'evaluateFte',
                width: 120,
            }, {
                title: '项目年产出',
                dataIndex: 'investigationYearOutput',
                key: 'investigationYearOutput',
                width: 120,
                render: text => (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }, {
                title: '启动中心数',
                dataIndex: 'startSiteNum',
                key: 'startSiteNum',
                width: 120,
            }, {
                title: '随机病例数',
                dataIndex: 'randomCaseNum',
                key: 'randomCaseNum',
                width: 120,
            }, {
                title: '研究周期 (估计时间)（月）',
                dataIndex: 'researchCycle',
                key: 'researchCycle',
                width: 120,
            }, {
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 140,
                fixed: 'right',
                render: (_, record) => {
                    const { curRole } = sessionStorage;
                    const {
                        seniorUserAuth,  //BO(王总)
                        talAuth,    //领域leader
                        deptBoAuth, //部门BO
                        pmlAuth,  //PML
                        pmAuth,  //PM
                        bdBaAuth,  //BD
                        evaluateStatus, //报价状态
                        lineChargeAuth,  //业务线负责人
                        specialDesignateUser,  //洪总、王利平、王勖
                        quotationState, //总价申请流程判断
                        secondEvaluationStatus,
                        haveAwardData, //最终报价判断
                        showEvaluateVersion, //是否有评估版本记录
                        showQuotationVersion, //是否有报价版本记录
                        haveTotalPriceData, //是否有总价申请记录
                        basePriceStatus,
                    } = record;
                    const {
                        clinicalQuotationState,   //总价申请状态
                        clinicalQuotationType,      //报价类型
                    } = (quotationState || {});

                    const operationCorrespondRoles = new Map([
                        ['view', {
                            name: '查看',
                            display: true,
                            editable: true,
                            event: () => this.UpdateRef.show(record, 'view'),
                            roles: ['*'],
                        }],
                        
                        ['repulse', {
                            name: '商务建议',
                            display: (specialDesignateUser || bdBaAuth) && (evaluateStatus == 'STATE_FOR_APPROVAL' || evaluateStatus == 'STATE_APPROVAL_REFUSED' || evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM'),
                            editable: true,
                            event: () => this.OperateReasonRef.show(record, 'repulse'),
                            roles: ['*'],
                        }],
                        ['examine', {
                            name: '总价审批',
                            display: (lineChargeAuth || seniorUserAuth || deptBoAuth) && evaluateStatus == 'STATE_FOR_RESTART_APPROVAL',
                            editable: true,
                            event: () => this.FloorPriceModalRef.show(record, 'examine', basePriceStatus),
                            roles: ['*'],
                        }],
                        ['confirm', {
                            name: '确认总价',
                            display: (specialDesignateUser || bdBaAuth) && (evaluateStatus == 'STATE_FOR_APPROVAL' || evaluateStatus == 'STATE_APPROVAL_REFUSED'),
                            editable: true,
                            event: () => this.confirmTotalPice(record, talAuth),
                            roles: ['*'],
                        }],
                        ['secEvaluation', {
                            name: '二次评估确认',
                            display: (seniorUserAuth || lineChargeAuth || deptBoAuth) && secondEvaluationStatus == 'TO_BE_CONFIRMED',
                            editable: true,
                            event: () => this.SecEvaluationRef.show(record),
                            roles: ['*'],
                        }],
                        ['TotalPiceRequestRecord', {
                            name: '总价申请记录',
                            //(evaluateStatus == 'STATE_FOR_APPROVAL' || evaluateStatus == 'STATE_FOR_RESTART_APPROVAL' || evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM' || evaluateStatus == 'STATE_PUBLISHED') &&
                            display:  haveTotalPriceData,
                            editable: true,
                            event: () => this.TotalPiceRequestRecordRef.show(record, talAuth),
                            roles: ['*'],
                        }],
                        ['visitQuotation', {
                            name: '访视报价',
                            // display: (((curRole == 'VP' || specialDesignateUser || seniorUserAuth || lineChargeAuth || deptBoAuth) && clinicalQuotationType == "CLINICAL_QUOTATION_TYPE_VISIT") || bdBaAuth) && (evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM' || evaluateStatus == 'STATE_PUBLISHED'),
                            display: (evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM' || evaluateStatus == 'STATE_PUBLISHED' || evaluateStatus == 'STATE_PUBLISHED_REEVALUATE_CONFIRM'),

                            editable: true,
                            event: () => this.showVisitQuotation(record),
                            roles: ['*'],
                        }],
                        ['fteQuotation', {
                            name: 'FTE报价',
                            display: (evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM' || evaluateStatus == 'STATE_PUBLISHED' || evaluateStatus == 'STATE_PUBLISHED_REEVALUATE_CONFIRM'),
                            editable: true,
                            event: () => this.showFteQuotation(record),
                            roles: ['*'],
                        }],
                        ['finalQuotation', {
                            name: '最终报价',
                            display: (curRole == 'VP' || specialDesignateUser || seniorUserAuth || bdBaAuth || deptBoAuth) && haveAwardData,
                            editable: true,
                            event: () => this.FinalQuotationRef.show(record),
                            roles: ['*'],
                        }],
                        ['versionRecord', {
                            name: '评估版本记录',
                            display: showEvaluateVersion,
                            editable: true,
                            event: () => this.VersionRecordRef.show(record),
                            roles: ['*'],
                        }],
                        ['quoteVersionRecord', {
                            name: '报价版本记录',
                            display: showQuotationVersion,
                            editable: true,
                            event: () => this.QuoteVersionRecordRef.show(record),
                            roles: ['*'],
                        }],
                        ['updateLog', {
                            name: '更新日志',
                            display: true,
                            editable: true,
                            event: () => this.UpdateLogRef.show(record),
                            roles: ['*'],
                        }],
                        ['operationLog', {
                            name: '操作日志',
                            display: true,
                            editable: true,
                            event: () => this.OperationLogRef.show(record, '1', true, talAuth),
                            roles: ['*'],
                        }],
                    ]);
                    return (
                        <span className="operateBarLineWrap">
                            {fp.compose(
                                fp.curry(cf.operationAuthByRole)(
                                    index => <span key={index} className="ant-divider" />
                                ),
                                fp.filter(i => !!i),
                                // 获取角色对应操作
                                fp.curry(cf.authDomList)(operationCorrespondRoles)
                            )(curRole)
                            }
                        </span>
                    );
                }
            }
        ];
        return columns;
    };

    affirm = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.confirmEvaluateRecord,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    refer = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.auditEvaluateRecord,
            data: {
                evaluateRecordId,
                approvalStatus: 'AGREE',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    showVisitQuotation = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getClinicalQuotation,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: (res) => {
                const { clinicalQuotationId } = res.data;
                const { searchParams, pagination } = this.state;
                this.props.saveEvaluateParams({
                    evaluateSearchParams: searchParams,
                    evaluatePagination: pagination,
                });
                this.doStartClinicalQuotation(clinicalQuotationId, evaluateRecordId);
                // if (clinicalQuotationCoefficient) {
                //     this.doStartClinicalQuotation(clinicalQuotationId, evaluateRecordId);
                // } else {
                //     Modal.confirm({
                //         iconType: 'question-circle',
                //         title: <div style={{ marginLeft: 42 }}>客户报价上浮比例未设置，是否仍要进行访视报价？</div>,
                //         onOk: () => {
                //             this.doStartClinicalQuotation(clinicalQuotationId, evaluateRecordId);
                //         },
                //     });
                // }
            }
        };
        $.sendRequest(options);
    }

    showFteQuotation = (record) => {
        const { evaluateRecordId } = record;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getClinicalQuotation,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: (res) => {
                const { clinicalQuotationId } = res.data;
                const { searchParams, pagination } = this.state;
                this.props.saveEvaluateParams({
                    evaluateSearchParams: searchParams,
                    evaluatePagination: pagination,
                });
                this.doStartClinicalFteQuotation(clinicalQuotationId, evaluateRecordId);
            }
        };
        $.sendRequest(options);
    }

    //初始化报价单
    doStartClinicalQuotation = (clinicalQuotationId, evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.doStartClinicalQuotation,
            data: {
                clinicalQuotationId,
            },
            dataType: 'json',
            doneResult: (res) => {
                location.href = `./#/clinicalEvaluation/visitQuotation/${evaluateRecordId}`;
            }
        };
        $.sendRequest(options);
    }

    //初始化FTE报价单
    doStartClinicalFteQuotation = (clinicalQuotationId, evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.doStartClinicalFteQuotation,
            data: {
                clinicalQuotationId,
            },
            dataType: 'json',
            doneResult: () => {
                location.href = `./#/clinicalEvaluation/fteQuotation/${evaluateRecordId}`;
            }
        };
        $.sendRequest(options);
    }

    confirmTotalPice = (record, talAuth) => {
        this.ConfirmTotalPiceModalRef.show(record, talAuth);
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        const { researchProductTypeId = [] } = searchParams;
        const curParams = this.splitParams(searchParams);
        const url = API_URL.evaluate.exportQuotationList;
        ExportUtil.export({
            ...curParams,
            researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
        }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    render() {
        const {
            data,
            loading,
            pagination,
            searchParams,
        } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='record' />
                <div className="main">
                    <Filter
                        search={this.search}
                        params={searchParams}
                        onChange={this.handleFilterChange}
                        dataExport={this.export}
                    />
                    <TableC
                        data={data}
                        scrollY={480}
                        loading={loading}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <Update 
                        loadData={this.loadData}
                        isBusinessOffer={true}
                        ref={el => this.UpdateRef = el}
                    />
                    <SchemeInfor
                        ref={el => this.SchemeInforRef = el}
                    />
                    <VersionRecord
                        ref={el => this.VersionRecordRef = el}
                    />
                    <UpdateLog
                        ref={el => this.UpdateLogRef = el}
                    />
                    <OperationLog
                        ref={el => this.OperationLogRef = el}
                    />
                    <OperateReason
                        loadData={this.loadData}
                        ref={el => this.OperateReasonRef = el}
                    />
                    <TotalPriceModal
                        loadData={this.loadData}
                        ref={el => this.TotalPriceModalRef = el}
                    />
                    <SecEvaluation
                        loadData={this.loadData}
                        ref={el => this.SecEvaluationRef = el}
                    />
                    <QuoteVersionRecord
                        loadData={this.loadData}
                        ref={el => this.QuoteVersionRecordRef = el}
                    />
                    <FinalQuotation
                        loadData={this.loadData}
                        ref={el => this.FinalQuotationRef = el}
                    />
                    <ConfirmTotalPiceModal
                        loadData={this.loadData}
                        ref={el => this.ConfirmTotalPiceModalRef = el}
                    />
                    <FloorPriceModal
                        loadData={this.loadData}
                        ref={el => this.FloorPriceModalRef = el}
                    />
                    <TotalPiceRequestRecord
                        ref={el => this.TotalPiceRequestRecordRef = el}
                    />
                    <UserDetail
                        ref={el => this.UserDetailRef = el}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        evaluateParams: state.clinicalEvaluationState.evaluateParams,
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveEvaluateParams: (params) => dispatch(saveEvaluateParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessOfferRecord);



// WEBPACK FOOTER //
// ./src/components/businessOffer/businessOfferRecord/index.js